import { Button } from "../ui/button";
import { Linkedin, Upload, CheckCircle2 } from "lucide-react";

const STEPS = [
  "Abre o teu perfil no LinkedIn",
  'Clica em "Mais" → "Guardar em PDF"',
  "Faz upload do PDF aqui em baixo",
];

const Row = ({ label, children, small = false }) => (
  <div>
    <span className="text-xs text-slate-400">{label}:</span>{" "}
    <span className={small ? "text-slate-700 text-xs" : "text-slate-800"}>{children}</span>
  </div>
);

/** Importação do perfil do LinkedIn a partir do PDF exportado. */
export const LinkedinImportCard = ({ importing, preview, onFileChange, onApply, onCancel }) => (
  <div className="bg-gradient-to-br from-blue-50 to-slate-50 border border-blue-100 rounded-2xl p-6">
    <div className="flex items-start gap-3 mb-4">
      <div className="w-8 h-8 rounded-lg bg-[#0A66C2] flex items-center justify-center shrink-0">
        <Linkedin className="w-4 h-4 text-white" />
      </div>
      <div>
        <p className="font-heading font-bold tracking-tighter text-slate-900">Importar perfil do LinkedIn</p>
        <p className="text-xs text-slate-500 mt-0.5">
          Exporta o teu perfil LinkedIn como PDF e importa-o aqui para preencher o teu perfil automaticamente.
        </p>
      </div>
    </div>

    <div className="bg-white/70 rounded-xl p-4 mb-4 space-y-1.5">
      <p className="text-xs font-bold text-slate-700 mb-2">Como exportar o PDF do LinkedIn:</p>
      {STEPS.map((step, i) => (
        <div key={step} className="flex items-start gap-2">
          <span className="w-5 h-5 rounded-full bg-[#0A66C2] text-white text-[10px] font-bold flex items-center justify-center shrink-0 mt-0.5">
            {i + 1}
          </span>
          <span className="text-xs text-slate-600">{step}</span>
        </div>
      ))}
    </div>

    {!preview && (
      <label className="flex items-center gap-3 p-3 bg-white border-2 border-dashed border-blue-200 rounded-xl cursor-pointer hover:border-[#0A66C2] transition-colors">
        <Upload className="w-4 h-4 text-blue-500 shrink-0" />
        <span className="text-sm text-slate-600">
          {importing ? "A importar perfil..." : "Clica para selecionar o PDF do LinkedIn"}
        </span>
        <input data-testid="linkedin-import-input" type="file" accept="application/pdf,.pdf"
          className="hidden" disabled={importing} onChange={onFileChange} />
      </label>
    )}

    {preview && (
      <div className="space-y-3">
        <p className="text-xs font-bold text-slate-700 flex items-center gap-1.5">
          <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" /> Dados extraídos — confirma antes de aplicar:
        </p>
        <div className="bg-white rounded-xl border border-black/5 p-4 space-y-2 text-sm">
          {preview.name && <Row label="Nome"><span className="font-medium">{preview.name}</span></Row>}
          {preview.headline && <Row label="Título">{preview.headline}</Row>}
          {preview.about && <Row label="Sobre" small>{preview.about}</Row>}
          {preview.district && <Row label="Distrito">{preview.district}</Row>}
          {preview.skills?.length > 0 && (
            <div>
              <span className="text-xs text-slate-400">Competências:</span>
              <div className="flex flex-wrap gap-1.5 mt-1">
                {preview.skills.map((s) => (
                  <span key={s} className="bg-blue-50 text-blue-700 text-[10px] font-medium px-2 py-0.5 rounded-full">{s}</span>
                ))}
              </div>
            </div>
          )}
          {preview.experience_summary && <Row label="Experiência" small>{preview.experience_summary}</Row>}
        </div>
        <div className="flex gap-2">
          <Button data-testid="linkedin-apply-btn" size="sm"
            className="rounded-full bg-[#0A66C2] hover:bg-[#0A66C2]/90 flex-1" onClick={onApply}>
            <CheckCircle2 className="w-3.5 h-3.5 mr-1.5" /> Aplicar ao perfil
          </Button>
          <Button size="sm" variant="outline" className="rounded-full" onClick={onCancel}>Cancelar</Button>
        </div>
      </div>
    )}
  </div>
);
